export const SocialNetwork = [
    {
        platform: "Email",
        icon: require("./assets/envelope.png").default,
        link: "mailto:jerry.hou@uwaterloo.ca"
    },
    {
        platform: "Github",
        icon: require("./assets/github.png").default,
        link: "https://github.com/bobthetitan7"
    },
    {
        platform: "Linkedin",
        icon: require("./assets/linkedin.png").default,
        link: "https://www.linkedin.com/in/jerry-h-a9757b200/"
    }
]